import constants from "../store/constants";
import {
  useFilteredObjects,
  useObject,
  usePagination,
  useForm,
} from "../../base";
import {
  getSingle,
  getPatchForm,
  performFilter,
  filterPagination,
} from "../store/actions";

export function useInsightsGoal(id) {
  const params = {
    storeName: constants.STORE_NAME,
    id: id,
    fetchMethod: getSingle,
  };
  return useObject(params);
}

export function useInsightsGoals(queryString) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: performFilter,
    querystring: queryString
  };
  return useFilteredObjects(params);
}

export function useInsightsGoalsPagination(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: filterPagination,
    querystring: querystring,
  };

  return usePagination(params);
}
